export default {
  common: {
    confirm: '確認',
    cancel: '取消',
    close: '關閉',
    gender: {
      male: '男/M',
      female: '女/F'
    },
    money: '<currency>JPY</currency> <amount>{{amount}}</amount>',
    moneyText: 'JPY {{amount}}',
    refundMethod: {
      credit: '信用卡',
      union: '銀聯卡',
      alipay: '支付寶',
      wechatpay: '微信支付',
      cash: '現金'
    }
  },
  components: {
    passportCamera: {
      hint: '請將護照資料頁對準框內',
      unavailable: '無法開啟相機，請使用系統相機拍攝或從相簿選擇。',
      systemCamera: '使用系統相機',
      album: '相簿',
      shoot: '拍照'
    }
  },
  views: {
    home: {
      title: '首頁',
      notice: '有待返還的消費稅',
      apply: '免稅申請',
      historyTitle: '申請紀錄',
      total: '總額',
      refundAmount: '預計退款',
      empty: '暫無申請記錄',
      loadError: '載入失敗，請稍後重試。',
      applyError: '申請提交失敗，請稍後重試。',
      status: {
        awaitingCustoms: '等待海關確認',
        notEligible: '不符合退稅條件',
        refunding: '退稅處理中',
        refunded: '退稅成功',
        refundFailed: '退稅失敗'
      }
    },
    landing: {
      title: '日本免稅退稅服務',
      description: '出境確認後，您透過 URL\n存取了本服務',
      next: '下一步'
    },
    login: {
      title: '日本免稅退稅服務',
      google: '使用 Google 登入',
      email: '使用電子郵件登入',
      emailLabel: '電子郵件地址',
      sendLink: '傳送登入連結',
      resendLink: '重新傳送登入連結',
      linkSent: '登入連結已傳送至 {{email}}。\n請查收郵件。',
      confirmEmail: '請重新輸入電子郵件地址以完成登入。',
      submit: '登入',
      loginError: '登入失敗，請稍後再試。',
      sendError: '傳送失敗，請稍後再試。'
    },
    passportInfo: {
      title: '護照資訊',
      nationality: '國籍',
      passportNumber: '護照號碼',
      lastName: '姓',
      firstName: '名',
      gender: '性別',
      dateOfBirth: '出生日期',
      dateOfExpiry: '有效期限',
      confirm: '確認',
      rescan: '辨識有誤・重新拍攝',
      scanError: '無法辨識護照，請重新拍攝。',
      bindError: '新增失敗，請稍後再試。'
    },
    passports: {
      title: '護照列表',
      add: '新增護照',
      empty: '請新增護照',
      pending: '{{num}}筆未申請',
      delete: '刪除',
      deleteConfirm: '確定刪除護照 {{number}} 嗎？',
      loadError: '載入失敗，請稍後再試。',
      deleteError: '刪除失敗，請稍後再試。',
      selectError: '切換護照失敗，請稍後再試。',
      logout: '登出'
    },
    taxInfo: {
      title: '填寫退稅單據資訊',
      passportLabel: '護照號碼',
      passportPlaceholder: '請輸入',
      lastNameLabel: '姓',
      lastNamePlaceholder: '請輸入',
      firstNameLabel: '名',
      firstNamePlaceholder: '中間名和名',
      expiryLabel: '護照有效期',
      verifyError: '護照資訊核對失敗，請檢查輸入內容。',
      submit: '核對並繼續'
    },
    residenceCert: {
      title: '在留資格證明書',
      notice: '為確認您已在海外居住 2 年以上，請提交以下任一證明文件。',
      documentLabel: '海外居住證明（任一項）',
      types: {
        permitDocumentTypeKosekiFukuhyo: '戶籍附票',
        permitDocumentTypeResidenceCertificate: '海外在留證明',
        permitDocumentTypeMynumberCard: '個人編號卡'
      },
      residenceStatusLabel: '在留資格',
      residenceStatusPlaceholder: '請選擇',
      permitTypes: {
        shipTourism: '船舶觀光上陸',
        crew: '乘員上陸',
        emergency: '緊急上陸',
        distress: '遇難上陸',
        sofa: '美軍人員',
        portCall: '寄港地上陸',
        transit: '過境上陸'
      },
      entryDateLabel: '入境日',
      settledDateLabel: '海外定居日',
      datePlaceholder: 'yyyy-mm-dd',
      addressLabel: '海外居住地',
      countryPlaceholder: '請選擇',
      uploadLabel: '上傳圖片',
      capture: '拍攝',
      removeImage: '刪除圖片',
      submit: '上傳',
      verifyError: '連結無效或已過期，請重新掃碼。'
    },
    uploadResult: {
      title: '上傳結果',
      done: '上傳完成',
      desc: '請返回 Kiosk 繼續操作',
      failed: '上傳失敗',
      failedDesc: '請重新操作'
    },
    statusDetail: {
      title: '申請狀態詳情',
      orderNo: '訂單編號 {{id}}',
      appliedAt: '申請日期 {{date}}',
      appliedAt_method: '申請日期 {{date}}｜{{method}}',
      total: '總額',
      taxAmount: '稅額',
      refundFee: '手續費',
      refundAmount: '預計退款',
      customsNotice:
        '出境時請在海關接受所購商品的確認。確認完成後將開始退款處理。',
      steps: {
        received: '申請受理完成',
        customsPending: '海關出境確認中',
        customs: '海關出境確認完成',
        customsFailed: '海關審核未通過',
        refunding: '退款處理中',
        refunded: '退款完成',
        refundFailed: '退款失敗'
      },
      remitNote: '通常 3〜5 個工作天',
      retry: '重新申請',
      retryError: '重新申請失敗，請稍後再試。',
      loading: '載入中...',
      loadError: '載入失敗，請稍後再試。'
    },
    notFound: {
      title: '頁面不存在',
      description: '您造訪的頁面不存在或已被移動。',
      backHome: '返回首頁'
    }
  }
};
